@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(821_771_811)
internal val Res.plurals.auth_banner_rate_limited_seconds: PluralStringResource by lazy {
      PluralStringResource("plurals:auth_banner_rate_limited_seconds", "auth_banner_rate_limited_seconds", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 10, 523),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 434),
      ))
    }

@delegate:ResourceContentHash(-51_344_861)
internal val Res.plurals.chat_pin_limit: PluralStringResource by lazy {
      PluralStringResource("plurals:chat_pin_limit", "chat_pin_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 10, 749),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 10, 536),
      ))
    }

@delegate:ResourceContentHash(-1_738_801_667)
internal val Res.plurals.chat_pinned_count: PluralStringResource by lazy {
      PluralStringResource("plurals:chat_pinned_count", "chat_pinned_count", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 760, 304),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 547, 227),
      ))
    }

@delegate:ResourceContentHash(-1_687_786_408)
internal val Res.plurals.chat_pinned_heading: PluralStringResource by lazy {
      PluralStringResource("plurals:chat_pinned_heading", "chat_pinned_heading", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 1065, 290),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 775, 181),
      ))
    }

@delegate:ResourceContentHash(2_102_182_547)
internal val Res.plurals.chat_pinned_open: PluralStringResource by lazy {
      PluralStringResource("plurals:chat_pinned_open", "chat_pinned_open", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 1356, 367),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 957, 226),
      ))
    }

@delegate:ResourceContentHash(536_296_224)
internal val Res.plurals.chat_typing_others: PluralStringResource by lazy {
      PluralStringResource("plurals:chat_typing_others", "chat_typing_others", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 1724, 345),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1184, 344),
      ))
    }

@delegate:ResourceContentHash(229_649)
internal val Res.plurals.chatlist_archived_chat_count: PluralStringResource by lazy {
      PluralStringResource("plurals:chatlist_archived_chat_count", "chatlist_archived_chat_count", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 10, 135),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 10, 162),
      ))
    }

@delegate:ResourceContentHash(280_533_318)
internal val Res.plurals.chatlist_archived_unread_description: PluralStringResource by lazy {
      PluralStringResource("plurals:chatlist_archived_unread_description", "chatlist_archived_unread_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 146, 423),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 173, 294),
      ))
    }

@delegate:ResourceContentHash(1_964_631_387)
internal val Res.plurals.chatlist_error_pin_limit: PluralStringResource by lazy {
      PluralStringResource("plurals:chatlist_error_pin_limit", "chatlist_error_pin_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 570, 743),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 468, 446),
      ))
    }

@delegate:ResourceContentHash(-2_096_169_444)
internal val Res.plurals.chatlist_row_unread_description: PluralStringResource by lazy {
      PluralStringResource("plurals:chatlist_row_unread_description", "chatlist_row_unread_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 1314, 338),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 915, 169),
      ))
    }

@delegate:ResourceContentHash(-1_797_996_840)
internal val Res.plurals.discover_comment_count: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_comment_count", "discover_comment_count", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 534, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 445, 180),
      ))
    }

@delegate:ResourceContentHash(-1_399_136_771)
internal val Res.plurals.discover_groups_counter_left: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_groups_counter_left", "discover_groups_counter_left", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10, 167),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10, 142),
      ))
    }

@delegate:ResourceContentHash(863_414_364)
internal val Res.plurals.discover_groups_counter_spoken_left: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_groups_counter_spoken_left", "discover_groups_counter_spoken_left", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 178, 258),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 153, 245),
      ))
    }

@delegate:ResourceContentHash(23_310_054)
internal val Res.plurals.discover_groups_counter_spoken_over: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_groups_counter_spoken_over", "discover_groups_counter_spoken_over", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 437, 514),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 399, 389),
      ))
    }

@delegate:ResourceContentHash(1_361_172_139)
internal val Res.plurals.discover_groups_like_comment: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_groups_like_comment", "discover_groups_like_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 952, 463),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 789, 378),
      ))
    }

@delegate:ResourceContentHash(399_449_145)
internal val Res.plurals.discover_groups_like_post: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_groups_like_post", "discover_groups_like_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 1416, 408),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 1168, 351),
      ))
    }

@delegate:ResourceContentHash(272_085_919)
internal val Res.plurals.discover_groups_pill_unfulfilled: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_groups_pill_unfulfilled", "discover_groups_pill_unfulfilled", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 1825, 587),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 1520, 526),
      ))
    }

@delegate:ResourceContentHash(1_701_286_699)
internal val Res.plurals.discover_groups_unlike_comment: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_groups_unlike_comment", "discover_groups_unlike_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 2413, 449),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 2047, 504),
      ))
    }

@delegate:ResourceContentHash(-601_659_079)
internal val Res.plurals.discover_groups_unlike_post: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_groups_unlike_post", "discover_groups_unlike_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 2863, 394),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 2552, 477),
      ))
    }

@delegate:ResourceContentHash(-903_236_347)
internal val Res.plurals.discover_new_posts_pill: PluralStringResource by lazy {
      PluralStringResource("plurals:discover_new_posts_pill", "discover_new_posts_pill", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 736, 422),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 626, 301),
      ))
    }

@delegate:ResourceContentHash(-1_954_630_479)
internal val Res.plurals.feed_age_hours: PluralStringResource by lazy {
      PluralStringResource("plurals:feed_age_hours", "feed_age_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_feed.commonMain.cvr", 10, 121),
        ResourceItem(setOf(), "${MD}values/strings_feed.commonMain.cvr", 10, 148),
      ))
    }

@delegate:ResourceContentHash(1_278_718_844)
internal val Res.plurals.feed_age_minutes: PluralStringResource by lazy {
      PluralStringResource("plurals:feed_age_minutes", "feed_age_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_feed.commonMain.cvr", 132, 139),
        ResourceItem(setOf(), "${MD}values/strings_feed.commonMain.cvr", 159, 154),
      ))
    }

@delegate:ResourceContentHash(-1_423_223_750)
internal val Res.plurals.freshness_hours: PluralStringResource by lazy {
      PluralStringResource("plurals:freshness_hours", "freshness_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1159, 282),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 928, 245),
      ))
    }

@delegate:ResourceContentHash(-1_271_561_931)
internal val Res.plurals.freshness_minutes: PluralStringResource by lazy {
      PluralStringResource("plurals:freshness_minutes", "freshness_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1442, 300),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1174, 251),
      ))
    }

@delegate:ResourceContentHash(835_128_862)
internal val Res.plurals.group_member_count: PluralStringResource by lazy {
      PluralStringResource("plurals:group_member_count", "group_member_count", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1743, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1426, 156),
      ))
    }

@delegate:ResourceContentHash(206_419_923)
internal val Res.plurals.profile_edit_bio_too_long: PluralStringResource by lazy {
      PluralStringResource("plurals:profile_edit_bio_too_long", "profile_edit_bio_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 10, 256),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 10, 259),
      ))
    }

@delegate:ResourceContentHash(-1_817_126_449)
internal val Res.plurals.profile_media_photo_count: PluralStringResource by lazy {
      PluralStringResource("plurals:profile_media_photo_count", "profile_media_photo_count", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 267, 200),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 270, 77),
      ))
    }

@delegate:ResourceContentHash(-2_125_330_652)
internal val Res.plurals.profile_settings_deletion_recovery: PluralStringResource by lazy {
      PluralStringResource("plurals:profile_settings_deletion_recovery", "profile_settings_deletion_recovery", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 468, 617),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 348, 556),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("auth_banner_rate_limited_seconds", Res.plurals.auth_banner_rate_limited_seconds)
  map.put("chat_pin_limit", Res.plurals.chat_pin_limit)
  map.put("chat_pinned_count", Res.plurals.chat_pinned_count)
  map.put("chat_pinned_heading", Res.plurals.chat_pinned_heading)
  map.put("chat_pinned_open", Res.plurals.chat_pinned_open)
  map.put("chat_typing_others", Res.plurals.chat_typing_others)
  map.put("chatlist_archived_chat_count", Res.plurals.chatlist_archived_chat_count)
  map.put("chatlist_archived_unread_description", Res.plurals.chatlist_archived_unread_description)
  map.put("chatlist_error_pin_limit", Res.plurals.chatlist_error_pin_limit)
  map.put("chatlist_row_unread_description", Res.plurals.chatlist_row_unread_description)
  map.put("discover_comment_count", Res.plurals.discover_comment_count)
  map.put("discover_groups_counter_left", Res.plurals.discover_groups_counter_left)
  map.put("discover_groups_counter_spoken_left", Res.plurals.discover_groups_counter_spoken_left)
  map.put("discover_groups_counter_spoken_over", Res.plurals.discover_groups_counter_spoken_over)
  map.put("discover_groups_like_comment", Res.plurals.discover_groups_like_comment)
  map.put("discover_groups_like_post", Res.plurals.discover_groups_like_post)
  map.put("discover_groups_pill_unfulfilled", Res.plurals.discover_groups_pill_unfulfilled)
  map.put("discover_groups_unlike_comment", Res.plurals.discover_groups_unlike_comment)
  map.put("discover_groups_unlike_post", Res.plurals.discover_groups_unlike_post)
  map.put("discover_new_posts_pill", Res.plurals.discover_new_posts_pill)
  map.put("feed_age_hours", Res.plurals.feed_age_hours)
  map.put("feed_age_minutes", Res.plurals.feed_age_minutes)
  map.put("freshness_hours", Res.plurals.freshness_hours)
  map.put("freshness_minutes", Res.plurals.freshness_minutes)
  map.put("group_member_count", Res.plurals.group_member_count)
  map.put("profile_edit_bio_too_long", Res.plurals.profile_edit_bio_too_long)
  map.put("profile_media_photo_count", Res.plurals.profile_media_photo_count)
  map.put("profile_settings_deletion_recovery", Res.plurals.profile_settings_deletion_recovery)
}
